import React from 'react'

const Progress = ({done}) => {
  return (
    <div className='progress'>
        <div className='progress-done' style={{
            opacity:1,
            width:`${done}%`,
            backgroundColor: "black",
        }}>
            {done}%

        </div>
    </div>
  )
}

export default Progress